import { RegistrationField } from '../../../../../interfaces/interfaces';
import { RegistrationFormFieldProps } from '../../RegistrationFormField';
import { CardSelectField } from './CardSelectField';
import { TraditionalSelectField } from './TraditionalSelectField';

interface RegistrationSelectInterface extends Omit<RegistrationFormFieldProps, 'register' | 'watch'> {
  isRequired: (field: RegistrationField) => boolean;
  textFieldSx?: any;
}
const RegistrationSelect = (props: RegistrationSelectInterface) => {
  if (props.field.selectDisplayMode === 'card') return <CardSelectField {...props} />;
  return <TraditionalSelectField {...props} />;
};
export default RegistrationSelect;
